/**
 * Ship Name Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.shipNameFormatter = function(value, row) {
    if (rights.includes("ships.show")) {
        return '<a href="/ships/show/'+row.ship_id+'">'+value+'</a>';
    } else if (value) {
        return value;
    }
};
